import { CryptoCurrencyIcon } from 'dashboard/components/ReportResult/CryptoCurrencyIcon';
import ListMatchEntity from 'dashboard/components/ReportResult/ListMatchEntity';
import { MatchIconPositive } from 'dashboard/components/ReportResult/MatchIcons';
import ReportResultLayout from 'dashboard/components/ReportResult/ReportResultLayout';
import TableLayout, { TableIconTD, TableTD, TableTH, TableTR } from 'dashboard/layouts/TableLayout';
import { ReportCryptoAddressWatchlist } from 'dashboard/models/report/crypto-address-watchlist';
import {
  translateWatchlistBirthdatesForDisplay,
  translateWatchlistMatchType,
} from 'dashboard/models/report/watchlist';
import Card from 'design-system/components/Card';

interface CryptoAddressProps {
  report: ReportCryptoAddressWatchlist;
  isRedacted: boolean;
  multiCardFormat: boolean;
}

const CryptoAddressWatchlist = ({
  report: {
    attributes: { result: result },
  },
  isRedacted,
  multiCardFormat = false,
}: CryptoAddressProps) => {
  if (isRedacted) {
    return <></>;
  } else if (result == null || result.length === 0) {
    return (
      <ReportResultLayout multiCardFormat={multiCardFormat}>
        <MatchIconPositive label='No matches found.' />
      </ReportResultLayout>
    );
  }

  const hit = result[0].entities?.[0];
  const matchedAddressContent = (
    <>
      <Card.Title>Affiliated addresses</Card.Title>
      <TableLayout
        isLoading={false}
        showHeader={true}
        isEmpty={false}
        nullState={null}
        headerTR={
          <>
            <TableTH>{/* Icon column */}</TableTH>
            <TableTH>Type</TableTH>
            <TableTH>Address</TableTH>
          </>
        }
      >
        {hit?.['crypto-addresses']?.map((rec, index) => (
          <TableTR key={index}>
            <TableIconTD>
              <CryptoCurrencyIcon cryptoCurrencyCode={rec.type} />
            </TableIconTD>
            <TableTD key={rec.type}>{rec.type}</TableTD>
            <TableTD key={rec.address}>{rec.address}</TableTD>
          </TableTR>
        ))}
      </TableLayout>
    </>
  );

  const watchlistHitContent = (
    <>
      <Card.Title>Match details</Card.Title>
      {result.map((match) => {
        const entity = match.entities?.[0];
        return (
          <ListMatchEntity
            key={match.name}
            url={match.url}
            name={match.name}
            flagCode={match.slug === 'internal-data-source' ? undefined : match['flag-code']}
          >
            <>
              {entity && entity['crypto-addresses'] ? (
                <div>
                  {[entity['crypto-addresses'][0].type, entity['crypto-addresses'][0].address]
                    .filter((item) => item)
                    .join(' • ')}
                </div>
              ) : null}
              {entity ? (
                <div>
                  {[
                    entity['alias-type']
                      ? translateWatchlistMatchType(entity['alias-type'])
                      : undefined,
                    entity.name,
                    ...translateWatchlistBirthdatesForDisplay(entity.birthdates),
                  ]
                    .filter((item) => item)
                    .join(' • ')}
                </div>
              ) : null}
            </>
          </ListMatchEntity>
        );
      })}
    </>
  );

  return (
    <ReportResultLayout multiCardFormat={multiCardFormat}>
      {watchlistHitContent}
      {matchedAddressContent}
    </ReportResultLayout>
  );
};

export default CryptoAddressWatchlist;
